import { Common, Company, device, utils, color } from '@stockbit/ui';
import Image from 'global/Image';
import styled from 'styled-components';

const { Flex, Input, Iconmoon } = Common;
const { ModalCompany } = Company;
const { hexOpacity } = utils;

const UserListContainer = styled.div`
  height: calc(100vh - 200px);
`;

const UserItemContainer = styled(Flex).attrs({
  align: 'center',
  justify: 'space-between',
  py: '10px',
})`
  padding-left: 15px;
  padding-right: 15px;
  @media ${device.tablet} {
    padding-left: 50px;
    padding-right: 50px;
  }
`;

const Search = styled(Input)`
  width: calc(100% - 100px) !important;
  margin: 0 50px;
  border: 1px solid transparent!important;
  background: #f9f9f9!important;
  padding: 6px 7px 6px 14px;
  border-radius: 10px!important;

  input {
    background: #f9f9f9!important;
    height: 30px!important;

    ::placeholder {
      color: ${color.black}${hexOpacity(0.65)}
      font-weight: bold;
    }
  }
`;

const CloseIcon = styled(Iconmoon).attrs({
  className: 'icon-widget_close',
})`
  left: -20px;
`;

const Modal = styled(ModalCompany)`
  .ant-modal-close {
    right: 32px;
    font-weight: bold;
  }
`;

const SearchIcon = styled(Image).attrs({
  src: '/icon/cari.svg',
  alt: 'search-icon',
})`
  width: 16px;
  margin-right: 5px;
`;

export {
  UserListContainer,
  UserItemContainer,
  Search,
  CloseIcon,
  SearchIcon,
  Modal,
};
